import { Route, Routes } from 'react-router-dom';
import Layout from './containers/Layout';
import CreateAccountLayout from './containers/Layout/CreateAccountLayout';
import CreateAccount404 from './pages/404';
import PartnerPage from './pages/[partnerId]';
import { StepsPage } from './pages/[partnerId]/steps';
import RegisterPage from './pages/register';
import Providers from './providers';

const App = () => {
  return (
    <Providers>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<RegisterPage />} />
          <Route path=":partnerId" element={<PartnerPage />} />
          <Route path="*" element={<CreateAccount404 />} />
        </Route>
        <Route element={<CreateAccountLayout />}>
          <Route path="/:partnerId/steps" element={<StepsPage />} />
          <Route
            path="/steps"
            element={<StepsPage partnerId="forge-trust" sessionEnabled />}
          />
          <Route path="/representative">
            <Route
              index
              element={<StepsPage partnerId="forge-trust-representative" />}
            />
            <Route
              path=":representativeCode"
              element={<StepsPage partnerId="forge-trust-representative" />}
            />
          </Route>
        </Route>
      </Routes>
    </Providers>
  );
};

export default App;
